import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-skeleton-loader',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="skeleton-item" [class.with-space]="withSpace">
      <div class="skeleton-circle"></div>
      <div class="skeleton-text" [style.width.px]="textWidth"></div>
      <div class="skeleton-badge" *ngIf="showBadge"></div>
    </div>
  `,
  styles: [`
    .skeleton-item {
      display: flex;
      align-items: center;
      gap: 12px;
      padding: 8px;
      margin-bottom: 8px;
    }

    .skeleton-circle {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
      background-size: 200% 100%;
      animation: shimmer 1.5s infinite;
    }

    .skeleton-text {
      height: 16px;
      border-radius: 4px;
      background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
      background-size: 200% 100%;
      animation: shimmer 1.5s infinite;
    }

    .skeleton-badge {
      width: 24px;
      height: 24px;
      border-radius: 12px;
      background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
      background-size: 200% 100%;
      animation: shimmer 1.5s infinite;
      margin-left: auto;
    }

    @keyframes shimmer {
      0% {
        background-position: 200% 0;
      }
      100% {
        background-position: -200% 0;
      }
    }
  `]
})
export class SkeletonLoaderComponent {
  @Input() withSpace = Math.random() > 0.5;
  @Input() showBadge = Math.random() > 0.7;
  @Input() textWidth = Math.floor(Math.random() * (100 - 60 + 1) + 60); // Random width between 60-100px
}
